import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { RenderComponent } from './render/render.component';

@Component({
  selector: 'app-render-view',
  templateUrl: './render-view.component.html',
  styleUrls: ['./render-view.component.css'],
})
export class RenderViewComponent {
  ngAfterViewInit(): void {
    this.generateRender();
  }

  @ViewChild('render', { read: ViewContainerRef })
  viewContainer!: ViewContainerRef;
  render!: RenderComponent;

  page = 1;

  @Input() body!: string;
  @Input() header!: string;

  @Output() data = new EventEmitter<any>();
  generateRender() {
    if (this.viewContainer) this.viewContainer.clear();
    const render = this.viewContainer.createComponent(RenderComponent);
    render.instance.page = this.page;
    render.instance.body = this.body;
    render.instance.header = this.header;
    this.page++;
    render.instance.data.subscribe((data) => {
      this.data.emit(data);
      if (data.length > 0) this.generateRender();
      else this.viewContainer.clear();
    });
  }
}
